import $ from 'jquery';
import formatDate from '../../../common/DateFormate';

// export const UserTableData = {
//   	tableId : 'users_table',
//   	ajaxUrl : 'admin/users',
//   	columns : [
//     { data: 'first_name', title: 'Name' },
//     { data: 'email', title: 'Email' },
//     { data: 'phone', title: 'Phone' },
//     { data: 'brand_name', title: 'Brand' },
//     { data: 'created_at', title: 'Created At' }
//   ]
// };

export const MarketPlaceAccountsTableData = {
  tableId: 'marketplace_accounts_table',
  tableIdParams:'marketplace-id',
  ajaxUrl: 'api/v1/marketplace_accounts',
  columns:  [
    { data: 'name', title:"Name"  },
    { data: 'marketplace', title :"Marketplace"  },
    { data: 'external_id', title :"External Id"  },
    { data: 'active', title :"Active"  },
    { data: 'last_sync', title :"Last Sync"  },
    { data: 'actions', title :"Actions", orderable: false, searchable: false }
  ]
};


export const ReportProcessingsTableData = {
  tableId: 'report_processings_table',
  tableIdParams:'report_processing_id',
  ajaxUrl: 'api/v1/report_processings',
  columns: [
    { data: "report_definition", title:"Report Definition" },
    { data: "file_format", title:"File Format" },
    { data: "status", title:"Status" },
    { data: "report_period_type", title:"Report Period Type" },
    { data: "marketplace_account", title:"Marketplace Account" },
    { data: "downloaded_at", title:"Downloaded At" },
    { data: "processed_at", title:"Processed At" },
    { data: "actions", title:"Actions", orderable: false, searchable: false }
  ],
};

export const ordersTableData = {
  tableId: 'orders_table',
  ajaxUrl: 'api/v1/orders',
  columns: [
    { data: "marketplace_id", title:"Marketplace" },
    { data: "product_id", title:"Product" },
    { data: "marketplace_account_id", title:"Marketplace Account" },
    { data: "is_business_order", title:"B2B/B2C" },
    { data: "external_order_id", title:"ID" },
    { data: "status", title:"Status" },
    { data: "fulfillment_channel", title:"Fulfillment Channel" },
    { data: "currency", title:"Currency" },
    { data: "quantity", title:"Quantity" },
    { data: "purchase_at", title:"Purchase At" },
    { data: "total_sale_amount", title:"Sale Amount" },
    { data: "total_net_sale_amount", title:"Net Sale Amount" },
    { data: "refund", title:"Refund" },
    { data: "product_price", title:"Product Price" },
    { data: "payment_mode", title:"Payment Mode" },
  ]
};

export const productsTableData = {
  tableId: 'products_table',
  ajaxUrl: 'api/v1/products',
  columns: [
    { data: "sku", title: "SKU"},
    { data: "asin", title: "ASIN"},
    { data: "title", title: "Title"},
    { data: "price", title: "Price"},
    { data: "mrp", title: "MRP"},
    { data: "marketplace_account_id", title: "Marketplace Account" },
    { data: "condition", title: "Condition" },
    { data: "fulfillment_channel", title: "Fulfillment Channel" },
    { data: "status", title: "Status"},
    { data: "quantity", title: "Quantity"},
    { data: "marketplace", title: "Marketplace"}
  ]
};

export const billingInvoiceTableData = {
  tableId: 'user-invoices',
  ajaxUrl: 'api/v1/invoices',
  columns: [
  { data: 'invoice_number',title: "Invoice Number",    render: function (data, type, row) {
      return `
        <span 
          class="invoice-number text-primary" 
          data-invoice-id="${row.id}" 
          style="cursor:pointer; text-decoration:underline;">
          ${data}
        </span>
      `;
    }, },
  { data: 'amount',title: "Amount"},
  { data: 'status' ,title: "Status"},
  { data: 'package_name',title: "Package Name"},
  { data: 'payment_method',title: "Payment Method" },
  { data: 'paid_at',title: "Paid At" },
  { data: 'created_at',title: "Created At" }
]
};


